import { defineReactiveModel, SessionMixin } from "vue-app-utils-web";
import "@/models/get-model";
import Model from "@/models/model";

const Session = defineReactiveModel({
  extends: Model,
  mixins: [
    SessionMixin
  ]
});

let _instance;

export function createSession (store) {
  if (!_instance) {
    _instance = new Session();
  }
  _instance.$store = store;
  return _instance;
}